// src/api/castaways.ts
import { Castaway } from '../types'; // Assuming types are defined in src/types.ts

export const getCastaways = async (leagueId: string): Promise<Castaway[]> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/leagues/${leagueId}/castaways`);
  if (!response.ok) {
    throw new Error('Failed to fetch castaways');
  }
  const data = await response.json();
  return data.castaways;
};
